
import Vue from 'vue'
import VueRouter from 'vue-router'
// import store from './store'

import store from '@/store/index.js';
import axiosInstance from '../axios/index'

const Home = () => import('../page/Home.vue');
const Login = () => import('../page/Login.vue');
const MainPage = () => import('../page/MainManage/Main.vue');
// 訂閱會員
const MemberList = () => import('../page/Subscriber/MemberList.vue');
const MemberDetail = () => import('../page/Subscriber/MemberDetail.vue');
const RecordList = () => import('../page/Subscriber/RecordList.vue');
const RecordInfo = () => import('../page/Subscriber/RecordInfo.vue');
// 諮詢紀錄
const ChatManage = () => import('../page/ChatManage/ChatList.vue');
const ChatRoom = () => import('../page/ChatManage/ChatRoom.vue');
// const ChatRecord = () => import('../page/ChatManage/ChatRecord.vue');
// 供應商管理
const VendorList = () => import('../page/VendorManage/VendorList.vue');
// 訂單管理
const OrderList = () => import('../page/OrderManage/OrderList.vue');
const OrderDetail = () => import('../page/OrderManage/OrderDetail.vue');
// CMS管理
const CmsControll = () => import('../page/CmsManage/CmsControll.vue');
// CMS Feedback管理
const CmsFeedback = () => import('../page/CmsManage/CmsFeedback.vue');
// CMS Shop管理
// const CmsShop = () => import('../page/CmsManage/CmsShop.vue');
// 照護數據
const EproOverview = () => import('../page/EproManage/EproOverview.vue');
// ePRO模組化
const EproModuleList = () => import('../page/EproManage/Modules/EproModuleList.vue');
const EproModuleTemplates = () => import('../page/EproManage/Modules/EproModuleTemplates.vue');
const EproModuleDetail = () => import('../page/EproManage/Modules/EproModuleDetail.vue');
const EproModuleEditor = () => import('../page/EproManage/Modules/EproModuleEditor.vue');
// 精選專欄
// const ScoopList = () => import('../page/ScoopManage/ScoopList.vue');
// const ScoopDetail = () => import('../page/ScoopManage/ScoopDetail.vue');
// 線上課程
const CourseList = () => import('../page/CourseManage/CourseList.vue');
const CourseDetail = () => import('../page/CourseManage/CourseDetail.vue');
const Page404 = () => import('../page/MainManage/Error404.vue');
const PageInvalid = () => import('../page/MainManage/Invalid.vue');

// 講座活動
const LectureList = () => import('../page/LectureManage/LectureList.vue');
const LectureDetail = () => import('../page/LectureManage/LectureDetail.vue');

// AI問答
const AiQa = () => import('../page/AiQaManage/AiQaList.vue');

Vue.use(VueRouter)
const routes = [
  {
    path: '/',
    name: 'index',
    component: Home,
    children: [
      {
        path: 'overview',
        name: 'Main',
        component: MainPage,
      },
      // 已訂閱會員
      {
        path: 'subscriber',
        name: 'MemberList',
        component: MemberList,
        props: (route) => ({
          query: route.query.q,
        }),
      },
      // 已訂閱會員 詳細資料
      {
        path: 'subscriber/:authId',
        component: MemberDetail,
        children: [
          {
            path: '',
            name: 'RecordList',
            component: RecordList,
          },
          {
            path: 'record/:rid',
            name: 'RecordInfo',
            component: RecordInfo,
          }
        ]
      },
      // 諮詢紀錄
      {
        path: 'chat',
        name: 'ChatManage',
        component: ChatManage,
        props: (route) => ({
          query: route.query.q,
        }),
      },
      {
        path: 'chat/:authId/:room',
        name: 'ChatRoom',
        component: ChatRoom,
      },
      {
        path: 'epro',
        name: 'EproOverview',
        component: EproOverview,
      },
      { // ePRO模組化列表
        path: 'epro/form',
        name: 'EproModuleList',
        component: EproModuleList,
      },
      { // ePRO模組化模板列表
        path: 'epro/formTemplate',
        name: 'EproModuleTemplates',
        component: EproModuleTemplates,
      },
      { // ePRO模組化詳細頁
        path: 'eproModule/editor',
        name: 'EproModuleEditor',
        component: EproModuleEditor,
      },
      { // ePRO模組化詳細頁
        path: 'eproModule/:form_hash',
        name: 'EproModuleDetail',
        component: EproModuleDetail,
      },
      // 廠商管理
      {
        path: 'vendor',
        name: 'VendorList',
        component: VendorList,
      },
      // 訂單管理
      {
        path: 'order',
        name: 'OrderList',
        component: OrderList,
        props: (route) => ({
          query: route.query.q,
        }),
      },
      {
        path:'order/:type/:id',
        name: 'OrderDetail',
        component: OrderDetail,
        props: true,
      },
      // 系統管理
      {
        path: 'system',
        name: 'System',
        component: CmsControll,
      },
      {
        path: 'feedback',
        name: 'Feedback',
        component: CmsFeedback,
      },
      // {
      //   path: 'shop',
      //   name: 'Shop',
      //   component: CmsShop,
      // },
      // 精選專欄
      // {
      //   path: 'scoop',
      //   name: 'ScoopList',
      //   component: ScoopList,
      // },
      // // 專欄詳細資料
      // {
      //   path: 'scoop/:id',
      //   name: 'ScoopDetail',
      //   component: ScoopDetail,
      // },
      // 線上課程列表
      {
        path: 'course',
        name: 'CourseList',
        component: CourseList,
      },
      // 線上課程詳細資料
      {
        path: 'course/:id',
        name: 'CourseDetail',
        component: CourseDetail,
      },
      // AI問答
      {
        path: 'aiqa',
        name: 'AiQa',
        component: AiQa,
      },
      {
        path: '/404',
        name: 'error404',
        component: Page404,
      },
      {
        path: '/invalid',
        name: 'Invalid',
        component: PageInvalid,
      },
      { // 講座活動列表
        path: 'lecture',
        name: 'LectureList',
        component: LectureList,
      },
      { // 講座活動內頁
        path: 'lecture/:id',
        name: 'LectureDetail',
        component: LectureDetail,
      },
    ]
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },
  {
    path: '*',
    redirect: { name: 'error404' },
  },
]

const router = new VueRouter({
  base: '/',
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  // 判斷有沒有這個頁面
  if (to.matched.length) {
    if (to.name !== 'Login') {
      const LOCAL_STORAGE = JSON.parse(localStorage.getItem('cc-cms'));
      // store.state.global.userProfile = STORAGE;
      console.log('INIT 1 LOCAL_STORAGE', LOCAL_STORAGE);

      if (LOCAL_STORAGE && LOCAL_STORAGE !== null) {
        axiosInstance('put', '/cms/auto_login', {
          lineid: LOCAL_STORAGE.lineid,
          code: LOCAL_STORAGE.code
        })
        .then((res) => {
          console.log('INIT 2 LOCAL_STORAGE', LOCAL_STORAGE);

          const UPDATE_STORAGE = {
            code: LOCAL_STORAGE.code,
            lineid: LOCAL_STORAGE.lineid,
            permission: res.identity,
          };

          const UPDATE_CONFIG = {
            code: LOCAL_STORAGE.code,
            lineid: LOCAL_STORAGE.lineid,
            permission: res.identity,
            business_subscribe: res.business_subscribe,
            subscriber: res.subscriber,
            team_id: res.team_id,
            auth_id: res.auth_id,
            first_name: res.first_name,
            last_name: res.last_name,
            character: res.character,
            gender: res.gender,
            thumbSrc: res.thumbSrc,
            team_profile: res.team_profile,
            team_belong: res.team_belong,
            epro_form: res.epro_form,
            // shop_bundle: res.shop_bundle,
          };

          const checkStorageProcess = new Promise((resolve) => {
            store.state.global.userProfile = UPDATE_CONFIG;
            localStorage.setItem('cc-cms', JSON.stringify(UPDATE_STORAGE));
            return resolve('next');
          });

          checkStorageProcess.then((value) => {
            if (value === 'next') {
              console.log('INIT 3 LOCAL_STORAGE', store.state.global.userProfile);
              next();
            }
          });
        })
        .catch(() => {
          store.state.global.userProfile = {};
          localStorage.removeItem('cc-cms');

          store.commit('global/UPDATE_MESSAGE_BOX', {
            active: true,
            type: 'error',
            content: '驗證碼錯誤或已失效',
          });

          next({name: 'Login'});
        })
      } else {
        next({ name: 'Login' });
      }
    } else {
      next();
    }
  } else {
    next({name: 'error404'});
  }
})

// router.beforeEach((to, from, next) => {
//   // 判斷有沒有這個頁面
//   if(to.matched.length) {
//     // 判斷當前是否在登入頁
//     if(to.name !== 'Login') {
//       const STORAGE = JSON.parse(localStorage.getItem('cc-cms'))
//       store.state.global.userProfile = STORAGE;
//       console.log('Router Login 1');
//       // 判斷localStorage有沒有資料
//       if(!STORAGE) {
//         // 記錄重導向路徑
//         // store.state.global.redirect = to.name;
//         console.log('Router Login 2 no storage');
//         next({name: 'Login'})
//       } else {
//         // 有資料判斷 是否與資料庫吻合
//         axiosInstance('put', '/cms/login', {
//           lineid: STORAGE.lineid,
//           code: STORAGE.code
//         }).then((res) => {
//           console.log('Router Login 3 process');

//           localStorage.setItem('cc-cms', JSON.stringify({
//             code: STORAGE.code,
//             lineid: STORAGE.lineid,
//             permission: res.identity,
//             subscriber: res.subscriber,
//             team_id: res.team_id,
//             auth_id: res.auth_id,
//             first_name: res.first_name,
//             last_name: res.last_name,
//             character: res.character,
//             gender: res.gender,
//             thumbSrc: res.thumbSrc,
//           }));

//           store.state.global.userProfile = {
//             code: STORAGE.code,
//             lineid: STORAGE.lineid,
//             permission: res.identity,
//             subscriber: res.subscriber,
//             team_id: res.team_id,
//             auth_id: res.auth_id,
//             first_name: res.first_name,
//             last_name: res.last_name,
//             character: res.character,
//             gender: res.gender,
//             thumbSrc: res.thumbSrc,
//           }

//           // if(res.identity !== 'admin' || res.identity === 'normal') {
//           //   // 驗證失敗，記錄重導向路徑並跳轉登入頁
//           //   store.state.global.redirect = to.name;
//           //   next({name: 'Login'})
//           // } else {
//           //   next();
//           // }
//           next();

//         }).catch(() => {
//           localStorage.removeItem('cc-cms');
//           next({name: 'Login'})
//         })
//       }
//     } else {
//       next();
//     }

//     if (to.name === 'VendorList' || 
//       to.name === 'OrderList' ||
//       to.name === 'OrderDetail' ||
//       to.name === 'System' ||
//       to.name === 'ScoopList' ||
//       to.name === 'ScoopDetail') {
      
//       if (store.state.global.userProfile.permission !== 'admin') {
//         next({name: 'Invalid'})
//       } else {
//         next();
//       }
//     }
//   } else {
//     console.log('跑錯地方了 這裡要改404頁面才對 之後再處理')
//     next({name: 'error404'})
//   }
// })

export default router
